<template>
  <div>
    <div class="bigTitle">定量</div>
    <div class="box">
      <div class="value physicians">
        <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/surveybg.png" alt="">
        </div>
        <div class="title">在线调查</div>
        <div class="text">
          <div class="one">
           我们拥有遍布亚洲地区的庞大资源库。我们通过资源库来管理调查和其他在线研究来支持我们的客户
          </div>
        </div>
        <div class="more" @click="toPath('/cn/onlinesurvey?source=webtable')">
           了解更多 ＞
        </div>
      </div>
      <div class="value patient">
        <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/modelingbg.png" alt="">

        </div>
        <div class="title"> 建模与分析</div>
        <div class="text">
          <div class="one">
           浩顿的建模和分析服务可帮助您管理大量未经过滤的数据集，从而提供直接而敏锐的业务见解。数据集可以来自结构良好的研究项目，也可以来自日常操作数据。

          </div>
        </div>
        <div class="more" @click="toPath('/cn/modeling?source=webtable')">
            了解更多 ＞
        </div>
      </div>
      <div class="value consumer">
        <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/programming/programmingbg.png" alt="">

        </div>
        <div class="title">编程与数据处理</div>
        <div class="text">
          <div class="one">
          浩顿提供全方位的研究服务，包括问卷编程、在线调查、数据处理和分析。
          </div>
        </div>
        <div class="more" @click="toPath('/cn/programming?source=webtable')">
          了解更多 ＞
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bigTitle{
  font-size: 40px;
  padding: 40px 120px 0;
  font-weight: 700;
}
.box {
  display: flex;
  justify-content: space-between;
  margin: 40px 120px 120px;
  .value {
    width: 32%;
    background-color: #2cb1e9;
  position: relative;

    // border: 1px solid #000;
     padding: 20px 20px 50px;

    color: #fff;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
   .img {
      width: 150px;
      overflow: hidden;
      img {
        width: 300px;
        transform: translateX(-50%); /* 向左平移50%以显示右半边 */
      }
    }
    .text {
      .one,
      .two {
        margin-top: 10px;
      }
    }
    .more {
      // margin-top: 15px;
            position: absolute;
  bottom: 15px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .bigTitle{
    font-size: 80px;
  }
  .box{
    flex-wrap: wrap;
    .value{
      width: 100%;
      padding: 30px;
      margin-bottom: 20px;
      padding-bottom: 150px;
      .title{
        font-size: 75px;
      }
      .img{
        width: 500px;
        img{
          width: 1000px;
        }
      }
      .text{
        font-size: 70px;
      }
      .more{
        font-size: 70px;
      }
    }
  }
}
</style>